import React from "react";
import { styled } from "@mui/system";
import { useHistory } from "react-router-dom";
import NoHoldingsSVG from "src/icons/NoHoldingsSVG";
import { useAppDispatch } from "src/store/store";
import { setPendingVerificationModal } from "src/store/features/modals.slice";
import { useUserSlice } from "src/store/features/user.slice";
import useVerificationNavigation from "src/components/common/useVerificationNavigation";

export const Message = styled("div")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "24px",
  fontSize: "14px",
  alignSelf: "stretch",
});

export const MessageButton = styled("button")({
  display: "flex",
  height: "25px",
  padding: "4px 8px",
  justifyContent: "center",
  alignItems: "center",
  gap: "8px",
  borderRadius: "4px",
  background: "#FC4C4C",
  color: "#FFF",
  cursor: "pointer",
  textDecoration: "none",
  fontWeight: 600,
  border: "none",

  "&:hover": {
    opacity: 0.5,
  },

  "&:focus": {
    backgroundColor: "#FFF6F6",
    color: "#FC4C4C",
  },
});

export const NoHoldingsContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  alignSelf: "stretch",
  gap: "24px",
});

interface YourPortfolioDefaultProps {
  isUnverified: boolean;
  selectedfilter: string;
}

const YourPortfolioDefault = (props: YourPortfolioDefaultProps) => {
  const { isUnverified, selectedfilter } = props;
  const history = useHistory();
  const { handleVerification } = useVerificationNavigation();

  const messageButton = isUnverified
    ? "Verify Now"
    : selectedfilter === "portfolio"
    ? "Deposit Now"
    : "Add tokens to watchlist";

  const message =
    selectedfilter === "watchlist"
      ? "Oops, your watchlist is looking a little empty."
      : "Oops, your portfolio is looking a little empty.";

  return (
    <NoHoldingsContainer id="no-holdings-container">
      <NoHoldingsSVG size={"120"} />
      <Message>
        {message}
        <MessageButton onClick={() => handleVerification(() => history.push("/wallets/deposit"))}>
          {messageButton}
        </MessageButton>
      </Message>
    </NoHoldingsContainer>
  );
};

export default YourPortfolioDefault;
